// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-block[data-v-61582f02] {\n  border: 1px dashed #8b5cf6;\n  background-color: #ede9fe;\n  width: 100%;\n}\n.field-hint[data-v-61582f02] {\n  margin: 6px 0 0;\n  color: #64748b;\n  font-size: 14px;\n  line-height: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
